export default {
  setStatus ({ state, commit }, value) {
    commit('setStatus', value)
  },
  setPartner ({ state, commit }, value) {
    commit('setPartner', value)
  },
  setPartnerStatus ({ state, commit }, value) {
    commit('setPartnerStatus', value)
  },
  setIdentStatus ({ state, commit }, value) {
    commit('setIdentStatus', value)
  },
  setIsPartner ({ state, commit }, value) {
    commit('setIsPartner', value)
  },
  setIdentStatusPartner ({ state, commit }, value) {
    commit('setIdentStatusPartner', value)
  }
}
